import { _updateLeadBatch } from 'controllers/leads/leads_controller';
import { useState } from 'react';

export const useUpdateLead = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateLead = async ({ schoolId, leadIds, values }) => {
    setLoading(true);
    setError(null);
    try {
      const res = await _updateLeadBatch(schoolId, leadIds, values);
      return res;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { updateLead, loading, error };
};
